import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

/**
 * 👾 Module which handles general purpose functionality for the application
 */
@Module
export default class SharedModule extends VuexModule {
  // 🚩 Flag for whether a losing indicator is shown on the app bar
  public appBarLoading: boolean = false;

  /**
   * 👾 Mutation that changes the app bar loading flag
   * @param loading
   */
  @Mutation
  public SET_APP_BAR_LOADING(loading: boolean) {
    this.appBarLoading = loading;
  }

  /**
   * 🔨 Changes the loading flag for the app bar
   * @param loading
   */
  @Action
  public changeAppBarLoading(loading: boolean) {
    this.context.commit("SET_APP_BAR_LOADING", loading);
  }
}
